import { FileApiData, FileNode } from "../interfaces/api.interface";
  
  export const transformFilesToTree = (files: FileApiData[], networkPath: string, codeCabinet: string): FileNode => {    
    
    const filesWithRelativePath = files.map(file => {
        return {
          file: getRelativePath(file.file, networkPath, codeCabinet),
          urlFetch: file.url ? '': reformatPathForCallApi(file.file, codeCabinet),
          url: file.url
        }
      });

    const createNode = (file: string, url: string, urlFetch: string =''): FileNode => ({
      file: file.split('/').pop() || file, 
      urlFetch,
      url,
      children: []
    });
  
    const rootNode: FileNode = { file: 'root', urlFetch: '', url: '', children: [] };
    
    filesWithRelativePath.forEach(({ file, urlFetch, url }) => {
      const parts = file.split('/');
      let currentLevel = rootNode;
  
      parts.forEach((part, index) => {

        let childNode = currentLevel.children!.find(node => node.file === part);
        
        if (!childNode) {

          childNode = createNode(part, index === parts.length - 1 ? url : '', urlFetch);
          currentLevel.children!.push(childNode);
        }
  
        currentLevel = childNode;
      });
    });

    if(rootNode.children && rootNode.children?.length > 0){
        return rootNode.children[0]
    } else {
        return { file: '', urlFetch:'', url: '' };
    }
  };

const getRelativePath = (fullPath: string, rootPath: string, codeCabinet: string) => {
    if (typeof fullPath !== 'string' || typeof rootPath !== 'string' || typeof codeCabinet !== 'string') {
      throw new Error('fullPath, rootPath and codeCabinet must be strings');
    }
    const cleanedRootPath = codeCabinet+rootPath.split(':')[1].replace(/\\/g, '/').replace(/\/$/, '');
    
    const fullPathSegments = fullPath.split('/');
    const rootPathSegments = cleanedRootPath.split('/');
  
    let commonIndex = 0;
    while (
      commonIndex < fullPathSegments.length &&
      commonIndex < rootPathSegments.length &&
      fullPathSegments[commonIndex] === rootPathSegments[commonIndex]
    ) {
      commonIndex++;
    }
  
    const relativeSegments = fullPathSegments.slice(commonIndex - 1);
    return relativeSegments.join('/').replace(/\/$/, '');
  }

const reformatPathForCallApi = (path: string, codeCabinet: string) => {
    return path.replace(codeCabinet, `w:`).replaceAll('/', '\\');
}